import Vue from 'vue'
import voca from "voca";

Vue.filter('prune', function (val, limit = 38) {
  return voca.prune(val, limit, " ...");
})